exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5d76e64a] .modal-journey .modal-dialog {\n  max-width: 90vw;\n  height: 90vh;\n}\n[data-v-5d76e64a] .modal-journey .modal-body {\n  height: calc(100vh - 250px);\n  max-height: calc(100vh - 250px);\n}\n[data-v-5d76e64a] .modal-journey .modal-body > div {\n  height: 100%;\n}\n[data-v-5d76e64a] .modal-journey .modal-body > div > form {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n[data-v-5d76e64a] .modal-journey .modal-body > div > form .automation-action-settings {\n  flex-grow: 1;\n  overflow: auto;\n}", ""]);

// exports
